type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`reveal max-w-2xl ${isCenter ? "mx-auto text-center" : ""}`}
    >
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100/70 px-3 py-1 text-xs font-medium tracking-wide text-primary-700">
        <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
          {description}
        </p>
      ) : null}
    </div>
  );
}